// extracted by mini-css-extract-plugin
export default {"root":"MenuList_root__HZBCn","title":"MenuList_title__A4yET"};